import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import moment from "moment";
import SearchFilterBox from "../../Components/SearchFilterBox";
import Table from "../../Components/Vendor/Table";
import AddVendor from "../../Components/Expenses/AddVendor";
import { toast } from "react-toastify";
import EditVendor from "../../Components/Vendor/EditVendor";
import DeleteVendor from "../../Components/Vendor/DeleteVendor";
import SideModal from "../../Components/SideModal";

const VendorList = () => {
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const [key, setKey] = useState("");
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [apiData, setApiData] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isAddVendor, setIsAddVendor] = useState(false);
  const [isEditVendor, setIsEditVendor] = useState(false);
  const [isDeleteVendor, setIsDeleteVendor] = useState(false);

  const fetchFunction = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;
    const response = await axios.get(`${Config.apiUrl}/vendor/list/new?${query}`, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess) {
      setApiData(res.vendors);
      setIsFocused(true);
    }
  };

  const getError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    isRefetching,
    data,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    getListMutate({ searchQuery, filterType });
  }, []);

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    getListMutate({
      searchQuery: values.searchQuery,
      filterType: values.filterType,
    });
  };

  const handleClearFilters = () => {
    setFilterType("");
    setSearchQuery("");
    getListMutate({ searchQuery: "", filterType: "" });
  };

  //------- Add vendor -------
  const addVendorFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/vendor/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddVendorSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsAddVendor(false);
      getListMutate({ searchQuery: "", filterType: "" });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddVendorError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addVendorLoading, mutate: addVendorMutate } = useMutation(
    addVendorFunction,
    {
      onSuccess: onAddVendorSuccess,
      onError: onAddVendorError,
    }
  );
  const handleAddVendorClose = () => {
    setIsAddVendor(false);
  };

  //------- Edit vendor -------
  const editVendorFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/vendor/edit`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditVendorSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsEditVendor(false);
      getListMutate({ searchQuery: "", filterType: "" });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditVendorError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editVendorLoading, mutate: editVendorMutate } =
    useMutation(editVendorFunction, {
      onSuccess: onEditVendorSuccess,
      onError: onEditVendorError,
    });
  const handleEditVendorClose = () => {
    setIsEditVendor(false);
  };

  //------- Delete Vendor -------
  const deleteVendorFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/vendor/delete`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteVendorSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsDeleteVendor(false);
      getListMutate({ searchQuery: "", filterType: "" });
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const deleteVendorError = (data) => {
    setIsDeleteVendor(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteVendorLoading, mutate: deleteVendorMutate } =
    useMutation(deleteVendorFunction, {
      onSuccess: deleteVendorSuccess,
      onError: deleteVendorError,
    });
  const handleVendorClose = () => {
    setIsDeleteVendor(false);
  };
  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Vendor List
          <Underline />
        </BoxTitle>
        <div className="flex space-x-4 md:ml-auto">
          <AddBtn
            type="button"
            onClick={() => {
              setKey(moment().unix());
              setIsAddVendor(true);
            }}
          >
            Add Vendor
          </AddBtn>
        </div>
      </BoxHead>

      <SideModal
        isOpen={isAddVendor}
        onClose={() => setIsAddVendor(false)}
      >
        <AddVendor
          addVendorMutate={addVendorMutate}
          addVendorLoading={addVendorLoading}
          handleClose={handleAddVendorClose}
        />
      </SideModal>

      <SideModal
        isOpen={isEditVendor}
        onClose={() => setIsEditVendor(false)}
      >
        <EditVendor
          editVendorMutate={editVendorMutate}
          editVendorLoading={editVendorLoading}
          handleClose={handleEditVendorClose}
          selectedData={selectedData}
        />
      </SideModal>


      {isDeleteVendor && (
        <DeleteVendor
          setIsDeleteVendor={setIsDeleteVendor}
          isDeleteVendor={isDeleteVendor}
          deleteVendorLoading={deleteVendorLoading}
          deleteVendorMutate={deleteVendorMutate}
          selectedData={selectedData}
          handleClose={handleVendorClose}
        />
      )}

      <FilterTableWrapper>
        <FilterWrapper>
          <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
            <SearchFilterBox
              options={searchOptions}
              handleFilterChange={handleFilterChange}
              handleClearFilters={handleClearFilters}
            />
          </div>
        </FilterWrapper>
        {!error && !isLoading && data && (
          <TableWrapper>
            <Table
              apiData={apiData || []}
              setSelectedData={setSelectedData}
              selectedData={selectedData}
              setIsEditVendor={setIsEditVendor}
              setIsDeleteVendor={setIsDeleteVendor}
            />
            {(!apiData || apiData.length === 0) && <NotFoundModel />}
          </TableWrapper>
        )}
      </FilterTableWrapper>

      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md`;
// const FilterWrapper = tw.div`flex w-full pb-4 lg:flex-row flex-col lg:gap-0 gap-4`;
const AddBtn = tw.button`whitespace-nowrap flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-primary-color hover:bg-hover-color py-2.5 text-sm`;

export default VendorList;
